const templateVars: { [char: string]: string } = {
  current_timestamp: Math.floor(Date.now() / 1000).toString(),
};

export function replaceTemplate(
  templateValue: string,
  varMapper = templateVars
) {
  const match = /^{{(?<name>\w+)}}$/.exec(templateValue);
  if (!match) return templateValue;

  const templateVarName = match!.groups!.name!;

  if (templateVarName in varMapper) {
    return varMapper[templateVarName];
  }

  throw new Error('Template variable undefined');
}
